import styled from 'styled-components';

export const StyledCheckoutForm = styled.div`
  .StripeElement {
    box-sizing: border-box;
    height: 40px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 7px;
    background-color: ${({ theme }) => theme.palette.background.default};
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 16px;
    line-height: 22px;
    padding: 10px;
    margin: 5px 0;
    cursor: pointer;
  }

  .StripeElement::placeholder {
    color: ${({ theme }) => theme.palette.text.disabled};
  }

  .StripeElement--focus {
    box-shadow: ${({ theme }) => theme.shadows[24]};
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  .StripeElement--invalid {
    border: 1px solid ${({ theme }) => theme.palette.error.main};
    background-color: ${({ theme }) => theme.palette.background.default};
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const Error = styled.div`
  color: ${({ theme }) => theme.palette.error.main};
`;
